// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#create .v-speed-dial{position:absolute}#create .v-btn--floating{position:relative}", ""]);
// Exports
module.exports = exports;
